module.exports = __webpack_public_path__ + "static/brainstorming-a301446441906fb45009788317a1409e.png";